<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card>
                        <v-card-title>
                        <v-icon large left color="secondary">mdi-monitor-eye</v-icon> Payment Monitoring
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                            <table class="va-table table2">
                                <tr>
                                  <th class="text-left" style="border-bottom: 1px solid #F96332; padding: 7px;">Sales date to pay</th>
                                  <th class="text-left" style="border-bottom: 1px solid #F96332; padding: 7px;">Details</th>
                                  <th class="text-left" style="border-bottom: 1px solid #F96332; padding: 7px;">Logs</th>
                                </tr>
                                  <tr v-for="(item,index) in DB_DATA" :key="index">
                                      <td>{{item.date}}</td>
                                      <td>
                                        Acct: {{parseData(item.data).acct}} <br />
                                        Amount: {{$money(parseData(item.data).amt)}} <br />
                                        SC: {{$money(parseData(item.data).sc)}} <br />
                                        TF: {{$money(parseData(item.data).tf)}} <br />
                                      </td>
                                      <td>
                                        <ul>
                                            <li
                                            v-for="(log,i) in parseData(item.data).logs" :key="index +'-'+i"
                                                style="padding: 2px; margin: 1px; font-size: 1em;"
                                              >
                                                {{log.action}}
                                          </li>
                                           </ul>
                                      
                                      </td>
                                  </tr>
                             
                            </table>
                          
                        </v-card-text>
                    </v-card>
            </v-col>
    </v-row>
    <!-- <va-settings-form :show="form" :settings="settings" :state="state" @DialogEvent="formEvent" /> -->
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        state: 'new',
        setting: {},
        payments:null,
        search:'',
        settings:[],
        headers: [
            { text: 'Name', align: 'right', sortable: false},
            { text: 'Value', sortable: false}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getSettings()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      DB_DATA(){
        let data =this.payments
        //let i = 0
        let _indexed = []
        for (const key in data) {
              console.log(`${key}: ${data[key]}`);
              _indexed.push({date: key, data: data[key]})
        }
        return _indexed

      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      parseData(data){
        let _data = null
        for (const key in data) {

              if (data.hasOwnProperty(key)) {
                _data = data[key]
              }
        }
        return _data
      },
       getSettings: function() { 
          const starCountRef = this.$refdb(this.$FBDB, 'payments');
          this.$onValuedb(starCountRef, (snapshot) => {
            this.payments = snapshot.val();
          });
     }
    }
  }
</script>